import React from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

const actions = [
  { id: 'qa-store', label: 'Visit My Store', icon: 'ArrowTopRightOnSquareIcon', href: '/member-personal-store', color: 'text-primary', bg: 'bg-primary/10' },
  { id: 'qa-products', label: 'Browse Products', icon: 'CubeIcon', href: '/product-catalog', color: 'text-blue-600', bg: 'bg-blue-50 dark:bg-blue-950/30' },
  { id: 'qa-share', label: 'Share My Store', icon: 'ShareIcon', href: '/member-dashboard', color: 'text-violet-600', bg: 'bg-violet-50 dark:bg-violet-950/30' },
  { id: 'qa-team', label: 'My Team', icon: 'UserGroupIcon', href: '/member-dashboard', color: 'text-emerald-600', bg: 'bg-emerald-50 dark:bg-emerald-950/30' },
  { id: 'qa-earnings', label: 'My Earnings', icon: 'BanknotesIcon', href: '/member-dashboard', color: 'text-amber-600', bg: 'bg-amber-50 dark:bg-amber-950/30' },
  { id: 'qa-academy', label: 'Academy', icon: 'AcademicCapIcon', href: '/member-dashboard', color: 'text-rose-500', bg: 'bg-rose-50 dark:bg-rose-950/30' },
];

export default function QuickActions() {
  return (
    <div className="grid grid-cols-3 sm:grid-cols-6 gap-3">
      {actions.map(action => (
        <Link
          key={action.id}
          href={action.href}
          className="card-elevated card-hover rounded-xl p-4 flex flex-col items-center gap-2.5 text-center group"
        >
          <div className={`w-10 h-10 rounded-xl ${action.bg} flex items-center justify-center group-hover:scale-110 transition-transform duration-200`}>
            <Icon name={action.icon as any} size={18} className={action.color} />
          </div>
          <span className="text-[11px] font-semibold text-foreground leading-tight">{action.label}</span>
        </Link>
      ))}
    </div>
  );
}